<div class="p-2">
  <button (click)="detectDevice()"
    type="button"
    id="detect_fingerprint_device"
    class="primary-btn mr-1 ml-1 mr-1"
    [disabled]="isDeviceConnected"
    [ngClass]="{
      'disabled': isDeviceConnected,
      'opacity-50': isDeviceConnected,
      'pointer-events-none': isDeviceConnected,
      'cursor-not-allowed': isDeviceConnected
    }">
    Detect Device
  </button>

  @if (isDeviceConnected) {
    <button
      (click)="disconnectDevice()"
      type="button"
      id="disconnect_device"
      class="primary-btn mr-1 ml-1 mr-1">
      Disconnect Device
    </button>
  }

  @if (isDeviceConnected) {
    <button (click)="captureFingerprint()" type="button" id="capture_fingerprint"
      class="primary-btn mr-1 ml-1">
      Capture Fingerprint
    </button>
  }

  <!-- Show device info if available -->
  @if (deviceInfo) {
    <div class="mt-2">
      <small class="text-muted">Device</small>
      <div class="font-weight-bold">
        {{ deviceInfo.DeviceType }} ({{ deviceInfo.ScannerName }})
      </div>
    </div>
  }

  @if (imageBase64) {
    <div class="capture_img">
      <h4>Captured Image:</h4>
      <img [src]="'data:image/png;base64,' + imageBase64" alt="Fingerprint Image">
      <!-- Submit Button Appears After Capturing Image -->
      <button (click)="submitFingerprint()" type="button"
        class="primary-btn mt-2">Submit
      </button>
    </div>
  }

</div>
